import {
    ImageContainer as SourceImageContainer,
} from 'SourceComponent/Image/Image.container';
import ImageComponent from './Image.component';
import React from 'react';

export class ImageContainer extends SourceImageContainer {
    // shouldComponentUpdate(nextprops) {
    //     return false;
    // }
}

export default ImageContainer;
